/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

import ReportLink from 'components/ReportsModule/components/common/ReportLink';
import ReportCard from 'components/ReportsModule/components/common/ReportCard';
import LwtTable, { ColumnProps } from 'components/@common/Table/LwtTable';
import { KeyClassroomEngagementStudentResult } from 'types/schema-generated-types';
import { ReportEntityType } from 'components/ReportsModule/types';

const getEnrichmentActivityColumns: (t: TFunction) => ColumnProps<any>[] = t => [
  {
    id: 'lastName',
    label: t('Student'),
    sortKey: 'student.lastName',
    getValue: item => (
      <ReportLink
        key={item.student.id}
        entityType={ReportEntityType.STUDENT}
        entityId={item.student.id}
      >
        {`${item.student.firstName} ${item.student.lastName}`}
      </ReportLink>
    ),
    sortable: true
  },
  {
    id: 'gradeLevel',
    label: t('Grade'),
    helpText: t('gradeLevel', { ns: 'ReportsHelpCommon' }),
    sortKey: 'student.gradeLevel',
    getValue: item => <Typography>{t(item.student.gradeLevel, { ns: 'GradeLevel' })}</Typography>,
    sortable: true
  },
  {
    id: 'curriculumWeek',
    label: t('Current Curriculum Week'),
    helpText: t('curriculumWeek', { ns: 'ReportsHelpCommon' }),
    sortKey: 'curriculumWeek',
    getValue: item => (
      <Typography>
        {item.curriculumWeek ? t('Week {{weekNumber}}', { weekNumber: item.curriculumWeek }) : '-'}
      </Typography>
    ),
    sortable: true
  },
  {
    id: 'myChoiceKeyboardingCompletedCount',
    label: t('My Choice Keyboarding'),
    helpText: t('myChoiceKeyboardingCompleted', { ns: 'ReportsHelpTableColumns' }),
    sortKey: 'enrichmentActivities.myChoiceKeyboardingCompletedCount',
    getValue: item => (
      <Typography>{item.enrichmentActivities?.myChoiceKeyboardingCompletedCount ?? 0}</Typography>
    ),
    sortable: true
  },
  {
    id: 'hearItTypeItCompletedCount',
    label: t('Hear It, Type It'),
    helpText: t('hearItTypeItCompleted', { ns: 'ReportsHelpTableColumns' }),
    sortKey: 'enrichmentActivities.hearItTypeItCompletedCount',
    getValue: item => (
      <Typography>{item.enrichmentActivities?.hearItTypeItCompletedCount ?? 0}</Typography>
    ),
    sortable: true
  }
];

const EnrichmentActivityTableCard: React.FC<{
  reportData: KeyClassroomEngagementStudentResult[];
  loading: boolean;
}> = ({ reportData = [], loading }) => {
  const { t } = useTranslation([
    'Reports',
    'ReportsHelpCommon',
    'ReportsHelpTableColumns',
    'GradeLevel'
  ]);
  const columns = getEnrichmentActivityColumns(t);

  return (
    <ReportCard
      title={t('Enrichment Activities')}
      loading={loading}
      reportData={reportData}
      reportDataProp="enrichmentActivities"
    >
      <LwtTable columns={columns} data={reportData} />
    </ReportCard>
  );
};

export default EnrichmentActivityTableCard;
